import * as Yup from 'yup';

const SubjectSchema = Yup.object().shape({
    englishName : Yup.string().min(3).max(255),
    arabicName : Yup.string().min(3).max(255),
})

export default SubjectSchema;